import React from 'react';
import styles from './AddUser.module.scss';
import UserDetails from './userDetails';
import { CustomModalIcon } from '../../../shared/customModalIcon';
import {  Col, Modal, Button, Row } from 'react-bootstrap';


const AddNewMembersModal = (props) => { 

    return (

        <div>
            <Modal
                show={props.show}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <Row>
                        <Col>
                            <Row className={styles.modalHeaderIconDiv}>
                                
                                {props.isCreateMode && 
                                    <CustomModalIcon
                                        type="squareOutlinedIcon"
                                        icon={
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        } 
                                    />
                                }
                                {!props.isCreateMode && 
                                <CustomModalIcon
                                    type="squareOutlinedIcon"
                                    icon={
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M15 8H8.6C8.03995 8 7.75992 8 7.54601 7.89101C7.35785 7.79513 7.20487 7.64215 7.10899 7.45399C7 7.24008 7 6.96005 7 6.4V3M17 21V14.6C17 14.0399 17 13.7599 16.891 13.546C16.7951 13.3578 16.6422 13.2049 16.454 13.109C16.2401 13 15.9601 13 15.4 13H8.6C8.03995 13 7.75992 13 7.54601 13.109C7.35785 13.2049 7.20487 13.3578 7.10899 13.546C7 13.7599 7 14.0399 7 14.6V21M21 9.32548V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548Z"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    } 
                                />
                                    
                                }
                            </Row>
                        </Col>
                    </Row>
                    <div>
                        {props.isCreateMode && <p className={styles.modalHeaderTopic}>Invite a new user to your hiring team</p>}
                        {!props.isCreateMode && <p className={styles.modalHeaderTopic}>Update user role</p>}

                        <p className={styles.modalHeaderSubTopic}>Users will have to logout and login again to see new permission changes </p>
                    </div>
                    <Col sm={12}>
                        {/* Rendering Content Goes Here */}
                        <UserDetails isCreateMode={props.isCreateMode} userDetails={props.userDetails}  reloadUsers={props.reloadUsers} handleClose={props.handleClose} userRolePermissions={props.userRolePermissions} />     
                    </Col>
                </Modal.Body>
            </Modal>
        </div>

    )
}

export default AddNewMembersModal;